import { createAsyncThunk } from '@reduxjs/toolkit'
import { types } from '@concordia/super-sdk'
import { SDK_CONTEXT } from 'state/context'
import { isEmptyOrNil } from 'toolbox/account'

export type FetchPortfolioPayload = {
  address: string
}

const MAX_ATTEMPTS = 5

export const fetchPortfolios = createAsyncThunk(
  'portfolios/fetchAll',
  async (payload: FetchPortfolioPayload): Promise<types.SPortfolio | null> => {
    const sdk = SDK_CONTEXT.superSdk
    if (!sdk) {
      throw new Error('SDK not initialized')
    }

    let attempt = 0
    const baseDelay = 1000

    while (attempt < MAX_ATTEMPTS) {
      try {
        const port = await sdk.fetcher.fetchPortfolioWithRisk(payload.address)
        if (isEmptyOrNil(port)) {
          throw new Error('Failed to fetch portfolio')
        }
        console.log('Portfolio: ', port)
        return port
      } catch (e: any) {
        attempt++
        console.log(`Attempt ${attempt}: Failed to fetch portfolio, retrying...`)

        if (attempt >= MAX_ATTEMPTS) {
          throw new Error(e.message || 'Failed to fetch portfolio after multiple attempts')
        }

        const delay = baseDelay * Math.pow(2, attempt - 1) // Exponential backoff formula
        console.log(`Waiting ${delay} ms before next attempt...`)

        await new Promise((resolve) => setTimeout(resolve, delay))
      }
    }
  }
)
